module.exports = __webpack_public_path__ + "static/media/titleLogo.1bb9c848.svg";